import {
  Grid,
  Radio,
  FormControl,
  FormControlLabel,
  IconButton,
  Alert,
  Snackbar,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Dialog,
  Backdrop,
  RadioGroup,
  Box,
  Typography,
  // FormLabel,
  Button,
  ButtonGroup
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import SubCard from 'ui-component/cards/SubCard';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// import Subcard from './Subcard';
import { IoMdClose } from 'react-icons/io';
import { DataGrid } from '@mui/x-data-grid';
// import MainCard from 'ui-component/cards/MainCard';
import { VscEye } from 'react-icons/vsc';
import Subcard from './Subcard';
import { DistrictIdApi, MapDetails, StateIdApi, ViewDetailsApi } from 'API/Mapping/Location_Maping';
import ViewDetail from './ViewDetail';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const LocationMapping = () => {
  const [FilterData, setFilterData] = useState({
    user_type: 'ds',
    state: '',
    map_type: 'mapped',
    district: ''
  });
  const [columnDefs, setColumnDefs] = useState([]);

  const [Error, setError] = useState(false);
  const [Isloading, setIsloading] = useState([]);
  const [MapData, setMapData] = useState([]);
  const [page, setPage] = useState(0); // Current page (starts from 0)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [TotalCount, setTotalCount] = useState('');
  const [ViewData, setViewData] = useState(null);
  const [Id, setId] = useState(null);
  const [DistrictData, setDistrictData] = useState([]);
  const [StateData, setStateData] = useState([]);
  //  const [ActiveCategory, setActiveCategory] = useState('mapped');
  const [Details, setDetails] = useState(false);
  const [ViewDetails, setViewDetails] = useState(false);
  const [Type, setType] = useState(null);
  const handleChange = (key, value) => {
    setFilterData((prev) => ({ ...prev, [key]: value }));

    if (key === 'user_type') {
      switch (value) {
        case 'ds':
          setColumnDefs([
            // { field: 'id', headerName: 'ID', width: 90 },
            { field: 'name', headerName: 'DS Name', width: 200 },
            { field: 'code', headerName: 'DS Code', width: 150 },
            { field: 'number', headerName: 'Mobile Number', width: 150 },
            { field: 'address', headerName: 'Address', width: 200 },
            { field: 'state', headerName: 'State', width: 110 },
            {
              field: 'action',
              headerName: 'Action',
              width: 150,
              renderCell: (params) => (
                <ButtonGroup size="small">
                  <Button
                    onClick={() => handleView(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<VscEye />}
                  >
                    View
                  </Button>
                  <Button
                    onClick={() => handleEdit(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<EditOutlinedIcon />}
                  >
                    Edit
                  </Button>
                </ButtonGroup>
              )
            }
          ]);
          break;
        case 'mds':
          setColumnDefs([
            // { field: 'id', headerName: 'ID', width: 90 },
            { field: 'name', headerName: 'MDS Name', width: 200 },
            { field: 'code', headerName: 'MDS Code', width: 150 },
            { field: 'number', headerName: 'Mobile Number', width: 150 },
            { field: 'address', headerName: 'Address', width: 200 },
            { field: 'state', headerName: 'State', width: 110 },
            {
              field: 'action',
              headerName: 'Action',
              width: 150,
              renderCell: (params) => (
                <ButtonGroup size="small">
                  <Button
                    onClick={() => handleView(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<VscEye />}
                  >
                    View
                  </Button>
                  <Button
                    onClick={() => handleEdit(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<EditOutlinedIcon />}
                  >
                    Edit
                  </Button>
                </ButtonGroup>
              )
            }
          ]);
          break;
        case 'sh':
          setColumnDefs([
            // { field: 'id', headerName: 'ID', width: 90 },
            { field: 'name', headerName: 'SH Name', width: 200 },
            { field: 'code', headerName: 'Employee ID', width: 150 },
            { field: 'number', headerName: 'Mobile Number', width: 150 },
            // { field: 'address', headerName: 'Address', width: 200 },
            // { field: 'state', headerName: 'State', width: 110 },
            {
              field: 'action',
              headerName: 'Action',
              width: 150,
              renderCell: (params) => (
                <ButtonGroup size="small">
                  <Button
                    onClick={() => handleView(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<VscEye />}
                  >
                    View
                  </Button>
                  <Button
                    onClick={() => handleEdit(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<EditOutlinedIcon />}
                  >
                    Edit
                  </Button>
                </ButtonGroup>
              )
            }
          ]);
          break;
        case 'tm':
          setColumnDefs([
            // { field: 'id', headerName: 'ID', width: 90 },
            { field: 'name', headerName: `TM Name`, width: 200 },
            { field: 'code', headerName: 'Employee ID', width: 150 },
            { field: 'number', headerName: 'Mobile Number', width: 150 },
            // { field: 'address', headerName: 'Address', width: 200 },
            // { field: 'state', headerName: 'State', width: 110 },
            {
              field: 'action',
              headerName: 'Action',
              width: 150,
              renderCell: (params) => (
                <ButtonGroup size="small">
                  <Button
                    onClick={() => handleView(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<VscEye />}
                  >
                    View
                  </Button>
                  <Button
                    onClick={() => handleEdit(params.row.id, params.row.user_type)}
                    sx={{
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    endIcon={<EditOutlinedIcon />}
                  >
                    Edit
                  </Button>
                </ButtonGroup>
              )
            }
          ]);
          break;

        default:
          setColumnDefs([]);
      }
    }
  };
  const handleView = (data, type) => {
    setViewDetails(true);
    ViewDetailsApi(type, data, setViewData, setIsloading, setError);
  };
  const handleEdit = (data, type) => {
    setDetails(true);
    setId(data);
    setType(type);
    ViewDetailsApi(type, data, setViewData, setIsloading, setError);
  };
  const refunctiondelete = () => {
    ViewDetailsApi(Type, Id, setViewData, setIsloading, setError);
  };
  const handleClear = () => {
    setColumnDefs([
      // { field: 'id', headerName: 'ID', width: 90 },
      { field: 'name', headerName: 'DS Name', width: 200 },
      { field: 'code', headerName: 'DS Code', width: 150 },
      { field: 'number', headerName: 'Mobile Number', width: 150 },
      { field: 'address', headerName: 'Address', width: 200 },
      { field: 'state', headerName: 'State', width: 110 },
      {
        field: 'action',
        headerName: 'Action',
        width: 150,
        renderCell: (params) => (
          <ButtonGroup size="small">
            <Button onClick={() => handleView(params.row.id, params.row.user_type)} endIcon={<VscEye />}>
              View
            </Button>
            <Button onClick={() => handleEdit(params.row.id, params.row.user_type)} endIcon={<EditOutlinedIcon />}>
              Edit
            </Button>
          </ButtonGroup>
        )
      }
    ]);
    setFilterData({
      user_type: 'ds',
      state: '',
      map_type: 'mapped',
      district: ''
    });
    // MapDetails(
    //   page + 1,
    //   rowsPerPage,
    //   {
    //     user_type: 'ds',
    //     state: '',
    //     map_type: 'mapped',
    //     district: ''
    //   },
    //   setIsloading,
    //   setMapData,
    //   setError,
    //   setTotalCount
    // );
  };

  const rows =
    MapData && Array.isArray(MapData)
      ? MapData.map((item) => ({
          id: item.user_id,
          name: item.username ? item.username : '-',
          code: item.usercode ? item.usercode : '-',
          user_type: item.user_type ? item.user_type : '-',
          state: item.state ? item.state : '-',
          address: item.address ? item.address : '-',
          number: item.mobile_number ? item.mobile_number : '-'
        }))
      : [];
  const [IsLoading, setIsLoading] = useState(false);

  const refunction = () => {
    setMapData([]);
    MapDetails(page + 1, rowsPerPage, FilterData, setIsloading, setMapData, setError, setTotalCount);
  };

  useEffect(() => {
    setMapData([]);
    MapDetails(page + 1, rowsPerPage, FilterData, setIsloading, setMapData, setError, setTotalCount);
  }, [FilterData, rowsPerPage, page]);

  useEffect(() => {
    setColumnDefs([
      // { field: 'id', headerName: 'ID', width: 90 },
      { field: 'name', headerName: 'DS Name', width: 200 },
      { field: 'code', headerName: 'DS Code', width: 150 },
      { field: 'number', headerName: 'Mobile Number', width: 150 },
      { field: 'address', headerName: 'Address', width: 200 },
      { field: 'state', headerName: 'State', width: 110 },
      {
        field: 'action',
        headerName: 'Action',
        width: 150,
        renderCell: (params) => (
          <ButtonGroup size="small">
            <Button
              onClick={() => handleView(params.row.id, params.row.user_type)}
              sx={{
                borderColor: '#688B2A',
                color: '#688B2A',
                borderRadius: '6px',
                '&:hover': {
                  borderColor: '#688B2A'
                }
              }}
              endIcon={<VscEye />}
            >
              View
            </Button>
            <Button
              onClick={() => handleEdit(params.row.id, params.row.user_type)}
              sx={{
                borderColor: '#688B2A',
                color: '#688B2A',
                borderRadius: '6px',
                '&:hover': {
                  borderColor: '#688B2A'
                }
              }}
              endIcon={<EditOutlinedIcon />}
            >
              Edit
            </Button>
          </ButtonGroup>
        )
      }
    ]);
  }, []);
  useEffect(() => {
    StateIdApi(setStateData, setIsLoading);
  }, []);
  useEffect(() => {
    if (FilterData?.state) {
      DistrictIdApi(setDistrictData, setIsLoading, FilterData?.state);
    }
  }, [FilterData?.state]);

  return (
    <>
      <Backdrop open={Isloading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setError(false)} variant="filled" severity="error" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      {/* dialog */}
      <Dialog
        open={ViewDetails}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            height: FilterData?.user_type === 'ds' ? '50vh' : '90vh',
            maxHeight: FilterData?.user_type === 'ds' ? '50vh' : '90vh'
            // display: 'flex',
            // flexDirection: 'column'
          }
        }}
        maxWidth={FilterData?.user_type === 'ds' ? 'md' : 'lg'}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4">{`${FilterData?.user_type?.toUpperCase()} Location Details`}</Typography>
        </DialogTitle>
        <IconButton
          sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', fontSize: '22px' }}
          onClick={() => setViewDetails(false)}
        >
          <IoMdClose />
        </IconButton>
        <DialogContent sx={{ marginBottom: 2, paddingBlock: 0 }} dividers>
          <ViewDetail ViewData={ViewData} FilterData={FilterData} Isloading={Isloading} />
        </DialogContent>
      </Dialog>

      {!Details ? (
        <Grid container>
          {/* <Grid item sm={12}> */}
          <SubCard
            sx={{ width: '100%' }}
            title={
              FilterData?.map_type === 'mapped'
                ? `Mapped ${FilterData?.user_type?.toUpperCase()}`
                : `UnMapped ${FilterData?.user_type?.toUpperCase()}`
            }
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={4} lg={2.5}>
                <FormControl fullWidth>
                  {/* <InputLabel id="user-type-label">Type of user</InputLabel> */}
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Type of user
                  </Typography>
                  <Select
                    labelId="user-type-label"
                    size="small"
                    value={FilterData.user_type || 'select'}
                    // label="Type of user"
                    onChange={(e) => handleChange('user_type', e.target.value)}
                  >
                    <MenuItem value="select" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="ds">Distributor</MenuItem>
                    <MenuItem value="mds">Master Distributor</MenuItem>
                    <MenuItem value="tm">Territory manager</MenuItem>
                    <MenuItem value="sh">State head</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2.5}>
                <FormControl fullWidth>
                  {/* <FormLabel>Status</FormLabel> */}
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Status
                  </Typography>
                  <RadioGroup
                    row
                    // name="status"
                    value={FilterData?.map_type || ''}
                    onChange={(e) => handleChange('map_type', e.target.value)}
                  >
                    <FormControlLabel value="mapped" control={<Radio size="small" />} label="Mapped" />
                    <FormControlLabel value="unmapped" control={<Radio size="small" />} label="Unmapped" />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {FilterData.user_type !== 'sh' && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={2.5}>
                    <FormControl fullWidth>
                      {/* <InputLabel id="state-label">State</InputLabel> */}
                      <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                        State
                      </Typography>
                      <Select
                        labelId="state-label"
                        size="small"
                        value={FilterData.state || 'select'}
                        // label="State"
                        onChange={(e) => handleChange('state', e.target.value)}
                      >
                        <MenuItem value="select" disabled>
                          Select
                        </MenuItem>
                        {IsLoading ? (
                          <MenuItem disabled>
                            <CircularProgress size={20} sx={{ mr: 1 }} />
                            Loading states...
                          </MenuItem>
                        ) : StateData && Array.isArray(StateData) ? (
                          StateData?.map((state) => (
                            <MenuItem value={state.state_id} key={state.state_id}>
                              {state.state_name.toUpperCase()}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem sx={{ pointerEvents: 'none', display: 'flex', justifyContent: 'center' }}>No state data found</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2.5}>
                    <FormControl fullWidth>
                      {/* <InputLabel id="district-label">District</InputLabel> */}
                      <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                        District
                      </Typography>
                      <Select
                        labelId="district-label"
                        value={FilterData.district || 'select'}
                        size="small"
                        // label="District"
                        onChange={(e) => handleChange('district', e.target.value)}
                        inputProps={{ readOnly: !FilterData.state }}
                      >
                        <MenuItem value="select" disabled>
                          Select
                        </MenuItem>
                        {IsLoading ? (
                          <MenuItem disabled>
                            <CircularProgress size={20} sx={{ mr: 1 }} />
                            Loading districts...
                          </MenuItem>
                        ) : (
                          DistrictData?.map((district) => (
                            <MenuItem value={district.district_id} key={district.district_id}>
                              {district.district_name.toUpperCase()}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={2} mt={3}>
                    <Button
                      color="secondary"
                      variant="outlined"
                      sx={{
                        backgroundColor: '#592375',
                        color: '#FFFFFF',
                        borderRadius: '6px',
                        '&:hover': {
                          backgroundColor: '#592375'
                        }
                      }}
                      size="small"
                      onClick={handleClear}
                    >
                      Clear
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
            {/* </SubCard> */}
            {/* </Grid> */}
            <Grid item sm={12} mt={1}>
              {/* <Subcard /> */}
              <Grid container>
                <Grid item xs={12}>
                  {/* <SubCard> */}
                  {/* <Typography variant="h3" mb={2}>
                    {FilterData?.map_type === 'mapped'
                      ? `Mapped ${FilterData?.user_type?.toUpperCase()}`
                      : `UnMapped ${FilterData?.user_type?.toUpperCase()}`}
                  </Typography> */}
                  <Box sx={{ height: 400, width: '100%' }}>
                    <DataGrid
                      rows={rows}
                      columns={columnDefs}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                            page: 0
                          }
                        }
                      }}
                      sx={{
                        '& .MuiDataGrid-columnHeaders': {
                          color: '#592375'
                        }
                      }}
                      autoHeight
                      pageSizeOptions={[5, 50, 100]}
                      paginationMode="server"
                      rowCount={TotalCount}
                      onPaginationModelChange={(paginationModel) => {
                        setPage(paginationModel.page);
                        setRowsPerPage(paginationModel.pageSize);
                      }}
                      getRowId={(row) => row.id}
                      // loading={Isloading}
                      disableRowSelectionOnClick
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </SubCard>
        </Grid>
      ) : (
        <Subcard
          setDetails={setDetails}
          FilterData={FilterData}
          ViewData={ViewData}
          Id={Id}
          setId={setId}
          refunction={refunction}
          refunctiondelete={refunctiondelete}
        />
      )}
    </>
  );
};

export default LocationMapping;
